import { DrawingToolsManager } from "../components/drawing-tools/drawing-tools.manager";

export interface ActualStartTimePosition {
    actualStartTimeT: number | null;
    actualXValue: number | null;
}

export class DrawingToolHelpers {
    public static calculateXPosition(actualXValue: number, actualStartTimeT: number, drawingToolManager: DrawingToolsManager): number {
        const startX = drawingToolManager.base.tiChartSeries.tiChartPoints.find(p => p.startTimeT == actualStartTimeT)?.xValue ?? null;
        if (!startX) {
            return actualXValue;
        }

        let xValueAbs = Math.abs(actualXValue);
        let xValueDecimal = startX - Math.floor(xValueAbs)

        return xValueAbs + xValueDecimal;
    }

    public static getActualStartTimePosition(point: any, drawingToolManager: DrawingToolsManager): ActualStartTimePosition | null {
        if (!point) { return null; }

        let actualXValue: number | null = null;
        let actualStartTimeT: number | null = null;
        if (point.actualStartTimeT > 0 && point.actualXValue > 0) {
            actualXValue = point.actualXValue
            actualStartTimeT = point.actualStartTimeT;
        } else {
            actualXValue = point.x;
            actualStartTimeT = drawingToolManager.base.tiChartSeries.tiChartPoints
                .find(p => p.xValue == Math.floor(actualXValue))?.startTimeT ?? null;
        }

        return {
            actualStartTimeT: actualStartTimeT,
            actualXValue: actualXValue
        };
    }

    public static isDrawingToolAnnotation(element: any): boolean {
        const isAnnotation = (element.className && element.className && element.className.baseVal && element.className.baseVal.indexOf('annotation') > -1)
                    || (element.parentElement && element.parentElement.className && element.parentElement.className.baseVal && (element.parentElement.className.baseVal.indexOf('annotation') > -1 || element.parentElement.className.baseVal.indexOf('control-points') > -1))
                    || (element.className && element.className.indexOf && element.className.indexOf('emoji-resize') > -1);
                
        return isAnnotation;
    }
}